<template>
    <div class="content__container">
        <div v-if="isShowMenu" class="menu_couriers">
            <menu_couriers
                :key="'menu_couriers'"
            />
        </div>
        <div v-if="isShowCourier" class="courier">
            <spinner
                v-if="isLoadingInfo"
                :key="'spinner_loading_info'"
                :height="'100px'"
                :width="'10px'"
            />
            <div v-else class="courier__wrapper">
                <div v-if="!isCouriers" class="courier__clear">
                    <span class="courier__clear_text">{{
                            __t('O.TO_CALL_COURIER_CLICK_CREATE_ORDER_AND_ENTER_NUMBER')
                        }}</span>
                </div>
                <div v-if="isLoadCouriersOrdersPooling" class="courier__wrapper_content">
                    <spinner
                        :key="'spinner_courier_loadData'"
                    />
                </div>
                <div v-if="!isLoadCouriersOrdersPooling && isCouriers" class="courier__wrapper_content">
                    <div v-if="isMobileScreen" class="courier_new__heading">
                        <button class="courier_new__heading_back" @click.prevent="clickBackArrow">
                            <div class="courier_new__heading_back_arrow margin_left">
                                <svg>
                                    <use xlink:href="/icons/base.svg#back_arrow"></use>
                                </svg>
                            </div>
                            <div class="courier_new__heading_back_text">
                                {{ numberCourier }}
                            </div>
                        </button>
                    </div>

                    <div v-if="isMobileScreen" class="rest_list__header">
                        <div class="rest_list__header_container">
                            <courier_list_header_item
                                v-for="item in courierListHeader"
                                :key="'order_list_header_item' + item.id"
                                :item="item"
                                @select_item_header="selectItemHeader"
                            />
                        </div>
                    </div>

                    <div class="courier__wrapper_content_data">
                        <div v-if="isShowCourierDelivery" class="courier__wrapper_content_data_take_delivery">
                            <div class="courier_take">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <div class="courier_title_number">
                                                <span class="courier_title_number_text">1</span>
                                            </div>
                                            <span class="courier_title_text">{{ __t('O.PICK_UP_ORDER') }}</span>
                                            <div v-if="statusText !== ''" class="order_pos__title_state">
                                                <div class="order_pos__title_state_text">
                                                    {{ statusText }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="courier__list">
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.RESTAURANT') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{ restaurantName }}</span>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.ADDRESS') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{ restaurantAddress }}</span>
                                            </div>
                                        </div>
<!--                                        <div class="courier_info">-->
<!--                                            <span class="courier_info_title">{{ __t('O.COMMENT') }}</span>-->
<!--                                            <div class="courier_info_details">-->
<!--                                                <span class="courier_info_details_text">{{ restComment }}</span>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="courier_info">-->
<!--                                            <span class="courier_info_title">{{ __t('O.RESTAURANT_INFO') }}</span>-->
<!--                                            <div class="courier_info_details">-->
<!--                                                <span class="courier_info_details_text">{{ __t('O.RESTAURANT_CONTACT') }}</span>-->
<!--                                                <span class="courier_info_details_phone">{{ restPhone }}</span>-->
<!--                                            </div>-->
<!--                                        </div>-->
                                    </div>
                                </div>
                            </div>
                            <div class="courier_delivery">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <div class="courier_title_number">
                                                <span class="courier_title_number_text">2</span>
                                            </div>
                                            <span class="courier_title_text">{{ __t('O.DELIVER_ORDER') }}</span>
                                        </div>
                                        <button class="courier_title_edit" @click.prevent="openAddress">
                                            <svg>
                                                <use xlink:href="/icons/base.svg#icon_edit_inactive"></use>
                                            </svg>
                                        </button>
                                    </div>
                                    <div class="courier__list">
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.ADDRESS') }}</span>
                                            <div class="courier_info_details_icon">
                                                <span class="courier_info_details_text">{{ courierAddress }}</span>
                                                <div class="courier_info_details_icon_block">
                                                    <div class="courier_info_details_icon_block_icon">
                                                        <svg>
                                                            <use xlink:href="/icons/base.svg#icon_flag"></use>
                                                        </svg>
                                                    </div>
                                                    <span class="courier_info_details_icon_block_label">5.3км</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.COMMENT') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{ orderComment }}</span>
                                            </div>
                                        </div>
                                        <div class="courier_info">
                                            <span class="courier_info_title">{{ __t('O.CLIENT') }}</span>
                                            <div class="courier_info_details">
                                                <span class="courier_info_details_text">{{ orderClientName }}</span>
                                                <span class="courier_info_details_phone">{{ orderClientPhone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowMap && !isMobileScreen" class="courier__wrapper_content_data_take_delivery">
                            <div class="courier_take">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <span class="courier_title_text map">{{ restaurantName }}</span>
                                        <button class="courier_button no_stretch" @click.prevent="clickCloseMap">
                                            <span class="courier_button_text">{{ __t('O.CLOSE') }}</span>
                                        </button>
                                    </div>
                                    <div class="courier__map">
                                        <map_courier
                                            :key="'map_courier'"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="courier__wrapper_content_data_details_contact">
                            <div v-if="isShowCourierDetails" class="courier_details">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <span class="courier_title_text">{{ __t('O.ORDER_DETAILS') }}</span>
                                        </div>
                                    </div>
                                    <div class="courier__list details">
                                        <div class="courier_products">
                                            <span class="courier_products_label">{{ __t('O.POSITIONS') }}</span>
                                            <div class="courier_products_list">
                                                {{ orderDetailsPositions }}
                                            </div>
                                        </div>
                                        <div class="courier_total">
                                            <span class="courier_total_label">{{ __t('O.TOTAL') }}</span>
                                            <span class="courier_total_sum">{{ orderDetailsTotal }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="isShowCourierContact" class="courier_contact support">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <span class="courier_title_text">{{ supportInfo }}</span>
                                        </div>
                                    </div>
                                    <div class="courier__list details">
                                        <div class="courier_aggregator_title_container">
                                            <div class="courier_aggregator">
                                                <div class="courier_aggregator_contact">
                                                    <a :href="hrefSupportPhone" class="courier_aggregator_contact_phone color call">{{ supportPhone }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="isShowCourierContact" class="courier_contact info">
                                <div class="courier_container">
                                    <div class="courier__heading">
                                        <div class="courier_title">
                                            <span class="courier_title_text">{{ __t('O.COURIER') }}</span>
                                        </div>
                                    </div>
                                    <div class="courier__list details">
                                        <div class="courier_aggregator_title_container">
                                            <div class="courier_aggregator">
                                                <svg_container
                                                    :key="'svg_container_aggregator'"
                                                    :iconSvg="iconAggregator"
                                                />
                                                <div v-if="isLoadCourierStatus" class="courier_aggregator_title">
                                                    {{ titleAggregator }}
                                                </div>
                                                <div v-else class="courier_aggregator_contact">
                                                    <span class="courier_aggregator_contact_name">{{
                                                            courierInfoCourierName
                                                        }}</span>
                                                    <span class="courier_aggregator_contact_phone">{{
                                                            courierInfoCourierPhone
                                                        }}</span>
                                                </div>
                                            </div>
                                            <spinner_dots
                                                v-if="isLoadCourierStatus"
                                                :key="'spinner_dots'"
                                                :size="'8px'"
                                            />
                                            <a v-else :href="'tel:' + courierInfoCourierPhone"
                                               class="courier_aggregator_icon_phone">
                                                <img src="/icons/phone.svg">
                                            </a>

                                        </div>
                                        <div v-if="!isLoadCourierStatus" class="courier_status">
                                            <div class="courier_status_container">
                                                <courier_status_item
                                                    v-for="item in statusList"
                                                    :key="'courier_status_item_' + item.id"
                                                    :item="item"
                                                />
                                            </div>
                                            <button class="courier_button" @click.prevent="clickShowMap">
                                                <span class="courier_button_text">{{ __t('O.SEE_ROUTE') }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="showButtonCancel" class="courier__wrapper_content_buttons">
                        <button class="courier_button" @click.prevent="cancelOrder">
                            <span class="courier_button_text">{{ __t('O.CANCEL') }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <modal_courier_map
        v-if="isShowMapModal"
        :key="'modal_courier_map'"
        :titleRestaurant="restaurantName"
    />
</template>

<script>

import menu_couriers from "../menu/courier/MenuCouriers.vue";
import {createHelpers} from "vuex-map-fields";
import spinner from "./../loader/Spinner.vue";
import {screenSize} from "../../mixins/screenSize";
import formatNumber from "../../mixins/formatNumber";
import courier_aggregator_block from "./aggregator/CourierAggregatorBlock.vue";
import checkbox_custom from "../CheckboxCustom.vue";
import svg_container from "./SvgContainer.vue";
import courier_status_item from "./status/CourierStatusItem.vue";
import spinner_dots from "../loader/SpinnerDots.vue";
import courier_list_header_item from "./CourierListHeaderItem.vue";
import modal from "../modal/Modal.vue";
import modal_courier_map from "./map/ModalCourierMap.vue";
import {touchEvent} from "../../mixins/touchEvent";
import {__t} from "../../helpers/translate";
import map_courier from "./map/MapCourier.vue";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

const {mapFields: mCouriers} = createHelpers({
    getterType: 'couriers/getCouriersField',
    mutationType: 'couriers/updateCouriersField',
})


export default {
    name: "courier",
    mixins: [formatNumber, screenSize, touchEvent],
    components: {
        modal,
        courier_list_header_item,
        courier_aggregator_block,
        checkbox_custom,
        menu_couriers,
        spinner,
        svg_container,
        courier_status_item,
        spinner_dots,
        modal_courier_map,
        map_courier
    },
    emits: ['click_back_arrow'],
    data() {
        return {
            addressInfo: {
                address: '',
                house: '',
                entrance: '',
                flat: ''
            },
            isShowMap: false,
            isShowMapModal: false,
            courierListHeader: [
                {id: 1, name: __t('O.COURIER'), isSelect: true},
                {id: 2, name: __t('O.DELIVERY'), isSelect: false},
                {id: 3, name: __t('O.DETAILS'), isSelect: false},
            ],
            courierHeaderItem: null,
            selectDate: null,
            selectTime: null,
        }
    },
    beforeMount() {
        EventBus.$on('load_order_delivery_info', this.loadOrderDeliveryInfo);
        EventBus.$on('click_item_menu_couriers', this.clickItemMenuCouriers);
        this.courierHeaderItem = this.courierListHeader[0];
        this.$store.dispatch('couriers/GET_COUNT_ALL_COURIERS');
        this.loadOrderDeliveryInfo();
    },
    beforeUnmount() {
        EventBus.$off('load_order_delivery_info', this.loadOrderDeliveryInfo);
        EventBus.$off('click_item_menu_couriers', this.clickItemMenuCouriers);
    },
    methods: {
        clickItemMenuCouriers() {
            this.isShowMapModal = false;
            this.isShowMap = false;
        },
        loadOrderDeliveryInfo() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo, 'order.delivery')) {
                this.getAddressInfoFromString(this.activeCourierOrderInfo.order.delivery);
            }
        },
        getAddressInfoFromString(deliveryAddress) {
            if (deliveryAddress.address) {
                this.addressInfo.address = deliveryAddress.address;
            }
            if (deliveryAddress.flat) {
                this.addressInfo.flat = deliveryAddress.flat;
            }
            if (deliveryAddress.house) {
                this.addressInfo.house = deliveryAddress.house;
            }
        },
        saveAddress(address) {
            this.addressInfo = address;
            this.closeAddress();
        },
        clickShowMap() {
            if (this.isMobileScreen) {
                this.isShowMapModal = true;
            } else {
                this.isShowMap = true;
            }
        },
        clickCloseMap() {
            this.isShowMap = false;
        },
        clickBackArrow() {
            this.$store.dispatch('couriers/STATE_SELECT_COURIER_ITEM', false);
        },
        selectItemHeader(itemHeader) {
            this.courierListHeader.forEach(item => item.isSelect = item === itemHeader);
            this.courierHeaderItem = itemHeader;
        },
        moveTouchDown() {
            this.isShowMapModal = false;
        },
        cancelOrder() {
            if (this.activeCourierOrder && this.activeCourierOrder.id) {
                this.$store.dispatch('couriers/CANCEL_ACTIVE_ORDER', {
                    idOrder: this.activeCourierOrder.id,
                    state: 'reject',
                    actionName: 'Cancel order'
                })
            } else {
                this.errorOutput('It is not possible to reject an active order');
            }
        },
    },
    computed: {
        ...mUser([
            'user',
        ]),
        ...mCouriers([
            'couriersOrdersPooling',
            'activeCourierOrder',
            'countAllCouriers',
            'isLoadCourierStatus',
            'isSelectCourierItem',
            'activeCourierOrderInfo',
            'stateCancelActiveOrder',
            'activeAggregator',
        ]),
        isCouriers() {
            return this.countAllCouriers > 0 || this.activeCourierOrder;
        },
        activeCourierId() {
            if (this.activeCourierOrder && this.activeCourierOrder.id) {
                return this.activeCourierOrder.id;
            }
            return '';
        },
        courierAddress() {
            if (this.addressInfo.address !== '') {
                return this.addressInfo.address;
            }
            return this.addressInfo.house + ', ' + this.addressInfo.entrance + ', ' + this.addressInfo.flat;
            // let address = '';
            // if (this.addressInfo.address !== '') {
            //     address += this.addressInfo.address;
            // }
            // if (this.addressInfo.house !== '') {
            //     if (address === '') {
            //         address += this.addressInfo.house;
            //     } else {
            //         address += ', ' + this.addressInfo.house;
            //     }
            // }
            // if (this.addressInfo.entrance !== '') {
            //     if (address === '') {
            //         address += this.addressInfo.entrance;
            //     } else {
            //         address += ', під\'їзд ' + this.addressInfo.entrance;
            //     }
            // }
            // if (this.addressInfo.flat !== '') {
            //     if (address === '') {
            //         address += this.addressInfo.flat;
            //     } else {
            //         address += ', кв. ' + this.addressInfo.flat;
            //     }
            // }
            // return address;
        },
        titleAggregator() {
            if (this.activeCourierOrder && this.activeCourierOrder.title) {
                return this.activeCourierOrder.title;
            }
            return '';
        },
        isSelectCourier() {
            if (!this.activeCourierOrderInfo.loadingInfo && this.activeCourierOrder) {
                return true;
            }
            return false;
        },
        iconAggregator() {
            if (this.getObjectPathProperty(this.activeCourierOrder, 'aggregator.icon')) {
                return this.activeCourierOrder.aggregator.icon;
            }
            return '';
        },
        isShowCourier() {
            return !this.isMobileScreen || (this.isMobileScreen && this.isSelectCourierItem);
        },
        isShowMenu() {
            return !this.isMobileScreen || (this.isMobileScreen && !this.isSelectCourierItem);
        },
        isShowCourierContact() {
            return !this.isMobileScreen || (this.isMobileScreen && this.courierHeaderItem.id === 1);
        },
        isShowCourierDelivery() {
            return (!this.isMobileScreen || (this.isMobileScreen && this.courierHeaderItem.id === 2)) && !this.isShowMap;
        },
        isShowCourierDetails() {
            return !this.isMobileScreen || (this.isMobileScreen && this.courierHeaderItem.id === 3);
        },
        numberCourier() {
            return 'G62YF'
        },
        showButtonCancel() {
            return !this.isMobileScreen || (this.isMobileScreen && this.courierHeaderItem.id === 1)
        },
        isLoadCouriersOrdersPooling() {
            if (this.couriersOrdersPooling.loading) {
                return this.couriersOrdersPooling.loading;
            }
            return false;
        },
        isLoadingInfo() {
            return this.activeCourierOrderInfo.loadingInfo || this.stateCancelActiveOrder;
        },
        restaurantName() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'pos_restaurant.title')) {
                return this.activeCourierOrderInfo.order.pos_restaurant.title;
            }
            return 'No title restaurant';
        },
        restaurantAddress() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'pos_restaurant.address')) {
                return this.activeCourierOrderInfo.order.pos_restaurant.address;
            }
            return 'No address restaurant';
        },
        restComment() {
            return '';
        },
        restPhone() {
            return '';
        },
        restaurantAdministrator() {

        },
        restaurantAdministratorPhone() {

        },
        orderAddress() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'delivery.address')) {
                return this.activeCourierOrderInfo.order.delivery.address;
            }
            return 'No title address'
        },
        orderComment() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'delivery.comment')) {
                return this.activeCourierOrderInfo.order.delivery.comment;
            }
            return ''
        },
        orderClientName() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'customer.name')) {
                return this.activeCourierOrderInfo.order.customer.name;
            }
            return 'No customer address';
        },
        orderClientPhone() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'customer.phone')) {
                return this.activeCourierOrderInfo.order.customer.phone;
            }
            return 'No customer phone';
        },
        orderDetailsPositions() {
            if (this.activeCourierOrderInfo.order && this.activeCourierOrderInfo.order.products && Array.isArray(this.activeCourierOrderInfo.order.products)) {
                let positions = '';
                this.activeCourierOrderInfo.order.products.forEach(item => {
                    if (positions !== '') {
                        positions += ', ';
                    }
                    positions += item.qty + 'x' + item.title;
                })
                return positions;
            }
            return '';
        },
        orderDetailsTotal() {
            let totalSum = 0;
            if (this.activeCourierOrderInfo.order && this.activeCourierOrderInfo.order.products && Array.isArray(this.activeCourierOrderInfo.order.products)) {
                this.activeCourierOrderInfo.order.products.forEach(item => {
                    totalSum += item.full_cost;
                })
                return this.toCurrency(totalSum, this.user.currency_suffix, 'uk-UA', 2);
            }
            return '';
        },
        isLoadCourierStatus() {
            return this.activeCourierOrderInfo.loadingLogs;
        },
        courierInfoCourierName() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'courier.name') && this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'courier.is_attached')) {
                if (this.activeCourierOrderInfo.order.courier.is_attached) {
                    return this.activeCourierOrderInfo.order.courier.name;
                }
            }
            return '';
        },
        courierInfoCourierPhone() {
            if (this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'courier.phone') && this.getObjectPathProperty(this.activeCourierOrderInfo.order, 'courier.is_attached')) {
                if (this.activeCourierOrderInfo.order.courier.is_attached) {
                    return this.activeCourierOrderInfo.order.courier.phone;
                }
            }
            return '';
        },
        statusText() {
            if (this.activeCourierOrderInfo.status) {
                return this.activeCourierOrderInfo.status
            }
            return '';
        },
        statusList() {
            if (this.activeCourierOrderInfo.logs && Array.isArray(this.activeCourierOrderInfo.logs)) {
                return this.activeCourierOrderInfo.logs;
            }
            return [];
        },
        supportInfo() {
            return `${this.__t('O.SUPPORT')}` + ' ' + 'Glovo On Demand';
        },
        supportPhone() {
            return '+380 89 320 2283';
        },
        hrefSupportPhone() {
            return 'tel:+380893202283';
        }
    }
}
</script>
